import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { ConversionSchema, type Conversion } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function useConversion(
  range: TimeRange,
  options: UseMetricOptions = {},
) {
  return useQuery<Conversion>({
    queryKey: qk.metrics.conversion(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/conversion?${toSearchParams(range).toString()}`,
        { signal },
      );
      return ConversionSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
